module.exports = __webpack_public_path__ + "static/media/laborArticle2.4468c386.jpg";